import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api') + '/partner';

export const getPartnerShows = createAsyncThunk('show/getAll', async ({ userId, theaterId }) => {
  const r = await axios.get(`${API}/shows/${userId}`, { params: { theaterId } }); return r.data;
});
export const createPartnerShow = createAsyncThunk('show/create', async ({ userId, showData }) => {
  const r = await axios.post(`${API}/shows/${userId}`, showData); return r.data;
});
export const updatePartnerShow = createAsyncThunk('show/update', async ({ userId, showId, data }) => {
  const r = await axios.patch(`${API}/shows/${userId}/${showId}`, data); return r.data;
});
export const deletePartnerShow = createAsyncThunk('show/delete', async ({ userId, showId }) => {
  const r = await axios.delete(`${API}/shows/${userId}/${showId}`); return r.data;
});
export const getPartnerMovies = createAsyncThunk('show/getMovies', async (search) => {
  const r = await axios.get(`${API}/movies`, { params: { search } }); return r.data;
});

const showSlice = createSlice({
  name: 'show',
  initialState: { shows: [], movies: [], loading: false, error: null },
  reducers: { clearShowState: (s) => { s.shows = []; } },
  extraReducers: (builder) => {
    builder
      .addCase(getPartnerShows.pending, (s) => { s.loading = true; })
      .addCase(getPartnerShows.fulfilled, (s, a) => { s.loading = false; s.shows = a.payload.shows; })
      .addCase(getPartnerShows.rejected, (s) => { s.loading = false; })
      .addCase(createPartnerShow.fulfilled, (s, a) => { s.shows.unshift(a.payload.show); })
      .addCase(updatePartnerShow.fulfilled, (s, a) => {
        const idx = s.shows.findIndex(sh => sh._id === a.payload.show._id);
        if (idx >= 0) s.shows[idx] = a.payload.show;
      })
      .addCase(deletePartnerShow.fulfilled, (s, a) => {
        s.shows = s.shows.filter(sh => sh._id !== a.meta.arg.showId);
      })
      .addCase(getPartnerMovies.fulfilled, (s, a) => { s.movies = a.payload.movies; });
  }
});

export const { clearShowState } = showSlice.actions;
export default showSlice.reducer;
